import { Link, useParams } from "react-router-dom";
import data from "../data";
import { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
const Info = () => {
	const [ids, setIds] = useState([]);
	const { id } = useParams();
	const info = data.filter((info) => {
		return info.id === parseInt(id);
	});
	let anotherCleandata = [];
	const { image, name, price, rate, about } = info[0];
	const { star, rating, review } = rate;
	useEffect(() => {
		let newData = [];
		if (localStorage.getItem("cart")) {
			let gettingData = [...JSON.parse(localStorage.getItem("cart"))];
			gettingData.forEach((element) => {
				newData.push(element);
			});
			setIds(newData);
		} else {
			newData.push("0");
			setIds(newData);
		}
	}, [id]);
	const getlocalData = (id) => {
		if (localStorage.getItem("cart")) {
			let gettingData = [...JSON.parse(localStorage.getItem("cart"))];
			let newdata = [...gettingData, id];
			anotherCleandata = [...new Set(newdata)];
			localStorage.setItem("cart", JSON.stringify(anotherCleandata));
		} else {
			localStorage.setItem("cart", JSON.stringify(id));
		}
	};
	return (
		<section>
			<div className='flex flex-col sm:flex-row text-center sm:text-left  p-5 mx-auto sm:my-10 justify-between items-start rounded'>
				<div className='w-full sm:w-1/3  '>
					<img src={image} alt='' className=' bg-cover m-auto' width='221' height='416' />
				</div>
				<div className='sm:w-50% sm:p-5 sm:mr-56 flex h-full flex-col flex-1   '>
					<h1 className='text-2xl mb-3 '>{name}</h1>
					<p className='mb-3'>
						<span className=' bg-custom-green p-1 text-white rounded'>
							<FaStar className='inline-block mb-1 mr-1' />
							{star}
						</span>
						<span className='text-small text-gray-400 ml-3'>{rating} Ratings </span>
						<span className='text-small text-gray-400 '>& {review} Reviews</span>
					</p>
					<h1 className='mb-3'>&#8377;{price}</h1>
					<div className='mb-3'>
						<p className='bg-gray-400 inline-block p-1 rounded'>Specs</p>
					</div>
					<ul className='list-disc text-left mx-5 sm:mx-0 mb-3'>
						{about.map((list, index) => {
							return <li key={index}>{list}</li>;
						})}
					</ul>
					<div className='mb-3 '>
						<p className='bg-gray-400 inline-block p-1 rounded'>Available offers</p>
					</div>
					<ul className='space-y-2 flex flex-col justify-start'>
						<li>
							<span className='inline-block'>
								<img src='https://rukminim1.flixcart.com/www/36/36/promos/06/09/2016/c22c9fc4-0555-4460-8401-bf5c28d7ba29.png?q=90' height='18' width='18' alt='' />
							</span>{" "}
							Bank OfferFlat INR 5000 Off on ICICI Bank Credit Cards and Credit EMI Transactions
						</li>
						<li>
							<span className='inline-block '>
								<img src='https://rukminim1.flixcart.com/www/36/36/promos/06/09/2016/c22c9fc4-0555-4460-8401-bf5c28d7ba29.png?q=90' height='18' width='18' alt='' />
							</span>{" "}
							Bank Offer5% Off On EMI Transactions Using Kotak Mahindra Bank Credit Cards
						</li>
						<li>
							<span className='inline-block'>
								<img src='https://rukminim1.flixcart.com/www/36/36/promos/06/09/2016/c22c9fc4-0555-4460-8401-bf5c28d7ba29.png?q=90' height='18' width='18' alt='' />
							</span>{" "}
							Bank Offer5% Off On EMI Transactions Using Yes Bank Credit Cards
						</li>
					</ul>
					{!ids.includes(id) ? (
						<div className=' text-center mt-5 self-center sm:mt-20'>
							<Link to='/cart' className=' bg-indigo-500 py-3 px-5 rounded' onClick={() => getlocalData(id)}>
								Add to Cart
							</Link>
						</div>
					) : (
						<div className=' text-center mt-5 self-center sm:mt-20'>
							<button className=' bg-red-400 py-3 px-5 rounded cursor-not-allowed' onClick={() => getlocalData(id)}>
								Already in Cart
							</button>
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default Info;
